module.exports = __webpack_public_path__ + "8b8e0cef2cd0c919ac21e2c149141a23.png";